import {TriggerExecution} from '../../../../generated/graphql';
import {
  getActionGQLTypename,
  getTriggerScopeType,
} from '../TriggersTable/utilData';
import {Trigger} from '../TriggersTable/utilTypes';

/**
 * Returns true if the trigger has not changed since the execution was triggered.
 * @param currentTrigger - The current trigger.
 * @param execution - The execution.
 * @returns True if the trigger has not changed since the execution was triggered.
 */
export const isSameTrigger = (
  execution: TriggerExecution,
  currentTrigger: Trigger
): boolean => {
  return (
    // Name must match
    currentTrigger.name === execution.triggerName &&
    // Scope must match
    currentTrigger.triggerScope.id === execution.scope?.id &&
    currentTrigger.triggerScope.scope ===
      (execution.scope?.__typename
        ? getTriggerScopeType(execution.scope.__typename)
        : undefined) &&
    // Event type must match
    currentTrigger.triggeringCondition.eventType ===
      execution.event?.eventType &&
    // Action type must match
    currentTrigger.triggeredAction?.actionType ===
      (execution.action?.actionType
        ? getActionGQLTypename(execution.action.actionType)
        : undefined)
  );
};
